import { Capacitor } from '@capacitor/core';

import { useAuthStore } from '@/shared/auth/authStore';
import { USER_ROLE } from '@/shared/constants';

import { useIsMobileViewport } from './useIsMobileViewport';

/**
 * capacitor-gate-erp에서 이식한 앱 전용 스타일을 보여줄지 결정한다.
 * 네이티브 앱이거나, 웹에서 모바일 폭 뷰포트로 접속했거나, student/parent로 로그인한 상태면 true.
 * maxViewportWidth로 뷰포트 기준 폭을 화면별로 넓힐 수 있다(기본: 모바일 브레이크포인트).
 * (로그인 전처럼 아직 role을 모르는 화면에서는 뷰포트 기준으로만 판단한다.)
 */
export function useIsAppStyle(maxViewportWidth?: number) {
  const isMobileViewport = useIsMobileViewport(maxViewportWidth);
  const userRole = useAuthStore((state) => state.userInfo.userRole);
  const isStudentOrParent = userRole === USER_ROLE.STUDENT || userRole === USER_ROLE.PARENT;
  return Capacitor.isNativePlatform() || isMobileViewport || isStudentOrParent;
}
